import { render } from "./TracesTable.vue?vue&type=template&id=7036c5b2&scoped=true"
import script from "./TracesTable.vue?vue&type=script&lang=js"
export * from "./TracesTable.vue?vue&type=script&lang=js"

import "./TracesTable.vue?vue&type=style&index=0&id=7036c5b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7036c5b2"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
